const topics = [
  { id: 1, name: '顶流恋情', heat: '98万', trend: 'up' },
  { id: 2, name: '综艺翻车', heat: '87万', trend: 'up' },
  { id: 3, name: '剧集结局', heat: '76万', trend: 'hot' },
  { id: 4, name: '明星街拍', heat: '65万', trend: 'up' },
  { id: 5, name: '网红争议', heat: '59万', trend: 'hot' },
  { id: 6, name: '体育转会', heat: '53万', trend: 'up' },
  { id: 7, name: '科技大战', heat: '48万', trend: 'up' },
  { id: 8, name: '海外八卦', heat: '41万', trend: 'stable' },
  { id: 9, name: '爆料合集', heat: '38万', trend: 'hot' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-600 text-sm md:text-base">当前最受关注的话题标签，点击探索更多</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#carousel"
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-full hover:border-primary-300 hover:bg-primary-50/20 transition-all duration-200 cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              {topic.trend === 'hot' && (
                <span className="flex items-center gap-0.5 text-xs text-primary-600">
                  <i className="ri-fire-line"></i>
                </span>
              )}
              {topic.trend === 'up' && (
                <span className="flex items-center gap-0.5 text-xs text-accent-600">
                  <i className="ri-arrow-up-line"></i>
                </span>
              )}
              <span className="text-xs text-foreground-500">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}